import { axiosInstance } from '@/plugins/axios';

// 服务器缓存控制接口
const caches = {
  set: (data = {}) => axiosInstance({
    url: 'Cache?actionId=1',
    method: 'post',
    data,
  }),
  get: (data = {}) => axiosInstance({
    url: 'Cache?actionId=2',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
  check: (data = {}) => axiosInstance({
    url: 'Cache?actionId=3',
    method: 'post',
    data,
  }),
};

export default caches;
